<template>
	<v-menu
		ref="menuConfig"
		bottom
		offset-y
		right
		min-width="450"
		max-width="450"
		content-class="container-notification-menu-header"
		:close-on-content-click="false"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				icon
				dark
				small
				color="#959595"
				class="mr-2"
				v-bind="attrs"
				v-on="on"
			>
				<v-icon dark>mdi-cog-outline</v-icon>
			</v-btn>
		</template>
		<div class="white" style="position: relative;">
			<div dense class="px-2 py-1" style="background: #959595;">
				<p class="caption mb-0 font-weight-bold white--text">Configuración Presupuestos</p>
			</div>
			<div class="pa-0">
				<v-tabs
					v-model="tab"
					background-color="#524D4D"
					grow
					dark
					height="40"
				>
					<v-tab>
						<div class="d-flex align-center">
							<p class="mb-0 font-weight-bold body-2">Prefijos y Títulos</p>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-icon small dark
												v-bind="attrs"
												v-on="on"
												class="ml-2">mdi-information</v-icon>
								</template>
								<span>En esta sección podrás administrar los tipos de presupuesto con los que tu empresa trabajará y que aparecerán en la tabla de correlativos</span>
							</v-tooltip>
						</div>
					</v-tab>
					<!-- <v-tab>Títulos</v-tab> -->
				</v-tabs>
				<v-tabs-items v-model="tab">
					<!-- <v-tab-item>
						<div class="pa-4">
							<div class="d-flex align-center">
								<v-text-field
									v-model="baseSerial"
									:loading="showLoading"
									outlined
									dense
									hide-details
									item-text="name"
									item-value="id"
									label="Número Base Para Correlativos"
									class="custom-height-search custom-height-calendar mt-2"
									color="#524D4D"
									@keypress="isNumberKey"
								></v-text-field>
							</div>
						</div>
					</v-tab-item> -->
					<v-tab-item>
						<div class="pa-4">
							<p class="mb-0 caption text-center" style="color: #524D4D">En esta sección podrás administrar los tipos de presupuesto con los que tu empresa trabajará y que aparecerán en la tabla de correlativos</p>
							<div class="d-flex flex-row align-center justify-space-between my-2 mb-0 px-2">
								<p class="mb-0 font-weight-bold body-2" style="color: #524D4D">Prefijos para Presupuesto</p>
								<!-- <div class="d-flex align-center">
									<p class="mb-0 font-weight-bold body-2" style="color: #524D4D">Prefijos para Presupuesto</p>
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-icon small
														v-bind="attrs"
														v-on="on"
														class="ml-2">mdi-information</v-icon>
										</template>
										<span>En esta sección podrás administrar los tipos de presupuesto con los que tu empresa trabajará</span>
									</v-tooltip>
									<p class="mb-0 caption" style="color: #524D4D">En esta sección podrás administrar los tipos de presupuesto con los que tu empresa trabajará</p>
								</div> -->
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn icon color="grey" class="mr-3"
													v-bind="attrs"
													v-on="on"
													small
													@click="setBudgetPrefix(null)">
											<v-icon>mdi-plus</v-icon>
										</v-btn>
									</template>
									<span>Nuevo prefijo para Presupuesto</span>
								</v-tooltip>
							</div>
							<v-divider class="my-2"></v-divider>
							<PrefixListingMenu :type="'budget'" />
						</div>
					</v-tab-item>
					<!-- <v-tab-item>
						<div class="pa-4">
							<div class="d-flex flex-row align-center justify-space-between my-2 mb-0 px-2">
								<p class="mb-0 font-weight-bold body-2" style="color: #524D4D">Títulos para Presupuesto</p>
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn icon color="grey" class="mr-3"
													v-bind="attrs"
													v-on="on"
													small
													@click="setBudgetTitle(null)">
											<v-icon>mdi-plus</v-icon>
										</v-btn>
									</template>
									<span>Nuevo título para Presupuestos</span>
								</v-tooltip>
							</div>
							<v-divider class="my-2"></v-divider>
							<TitlesListingMenu :type="'budget'" />
						</div>
					</v-tab-item> -->
				</v-tabs-items>
			</div>
		</div>
	</v-menu>
</template>

<script>
import _debounce from 'lodash/debounce'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import {updateCompanyConfig, getCompanyConfig} from '@/helpers/api/company'
import {removeBudgetPrefix, deleteBudgetTitle} from '@/helpers/api/budgets'
import PrefixListingMenu from '@/components/Helpers/Components/PrefixListingMenu'
// import TitlesListingMenu from '@/components/Helpers/Components/TitlesListingMenu'

export default {
	name: 'BudgetLeftButtons',
	components: {PrefixListingMenu},
	computed: {
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		showLoading(){
			return this.loading
		},
		companyBudgetPrefixes(){
			return this.$store.state.budget.companiesBudgetPrefixes.filter((prefix) => {
				return prefix.type == 'budget'
			})
		}
	},
	watch: {
		selectedCompany(newValue){
			if(newValue){
				this.getConfigs()
			}
		},
		baseSerial(newValue, prevValue) {
			if(prevValue && newValue && newValue > 0 && !this.loading){
				this.onChangeBaseSerial()
			}
		}
	},
	data: () => ({
		tab: 0,
		loading: false,
		baseSerial: null
	}),
	mounted(){
		if(this.selectedCompany){
			this.getConfigs()
		}
	},
	methods:{
		async getConfigs(){
			this.loading = true
			const config = await getCompanyConfig()
			if(config.code == 200){
				this.baseSerial = config.company_config?.base_serial
			}
			this.loading = false
		},
		onChangeBaseSerial: _debounce(function() { this.changeBaseSerial() }, 800),
		async changeBaseSerial(){
			if(this.loading) return

			this.loading = true
			const config = await updateCompanyConfig({
				base_serial: this.baseSerial
			})
			if(config.code == 200){
				eventBus.$emit('reloadInformation', {})
				this.$refs.menuConfig.save()
			}
			this.loading = false
		},
		isNumberKey(event) {
			const charCode = event.which ? event.which : event.keyCode;
			if (charCode < 48 || charCode > 57) {
				event.preventDefault();
			}
		},
		setBudgetPrefix(prefix = null){
			let newPrefix = {type: 'budget'}
			if(prefix){
				newPrefix = {
					...newPrefix,
					...prefix,
					...{budget_prefix_id: prefix.id}
				}
			}
			this.$store.commit('budget/setNewBudgetPrefixModalEditing', newPrefix)
      this.$store.commit('budget/setNewBudgetPrefixModal', true)
		},
		setBudgetTitle(title = null){
			this.$store.commit('budget/setNewBudgetTitleModalEditing', title ? {...title, ...{budget_title_id: title.id}}:null)
      this.$store.commit('budget/setNewBudgetTitleModal', true)
		},
		async deleteBugdetPrefix(prefix){
			await removeBudgetPrefix({budget_prefix_id: prefix.id})
			this.$store.dispatch('budget/getBudgetPrefixes')
		},
		async deleteBugdetTitle(title){
			await deleteBudgetTitle({budget_title_id: title.id})
			this.$store.dispatch('budget/getBudgetTitles')
		},
	}
}
</script>